import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", company: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created");
      nav("/app");
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="register-form">
          <Link to="/" className="mb-8 inline-flex items-center gap-2" data-testid="brand-link">
            <div className="grid h-7 w-7 place-items-center rounded-md bg-slate-900 text-white">
              <span className="font-display text-sm font-bold">T</span>
            </div>
            <span className="font-display text-lg font-semibold tracking-tight">Toastern</span>
          </Link>
          <div>
            <p className="font-mono-tight text-xs uppercase tracking-widest text-slate-500">// join</p>
            <h1 className="mt-2 font-display text-3xl font-semibold tracking-tight">Create your workspace</h1>
            <p className="mt-2 text-sm text-slate-600">Start free. Invite your team when you&apos;re ready.</p>
          </div>
          <div className="space-y-4">
            <div>
              <Label className="text-xs uppercase tracking-widest text-slate-500">Full name</Label>
              <Input data-testid="register-name" value={form.name} onChange={set("name")} className="mt-2 h-10 border-slate-200" required />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest text-slate-500">Work email</Label>
              <Input data-testid="register-email" type="email" value={form.email} onChange={set("email")} className="mt-2 h-10 border-slate-200" required />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest text-slate-500">Company</Label>
              <Input data-testid="register-company" value={form.company} onChange={set("company")} className="mt-2 h-10 border-slate-200" />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-widest text-slate-500">Password</Label>
              <Input data-testid="register-password" type="password" value={form.password} onChange={set("password")} className="mt-2 h-10 border-slate-200" required minLength={6} />
            </div>
          </div>
          <Button type="submit" disabled={loading} data-testid="register-submit" className="h-11 w-full rounded-md bg-slate-900 text-white hover:bg-slate-800">
            {loading ? "Creating…" : "Create workspace"}
          </Button>
          <p className="text-center text-sm text-slate-600">
            Already have an account?{" "}
            <Link to="/login" className="text-slate-900 underline" data-testid="link-login">Sign in</Link>
          </p>
        </form>
      </div>
      <div className="hidden border-l border-slate-200 bg-slate-50 lg:block">
        <div className="flex h-full flex-col justify-between p-12">
          <p className="font-mono-tight text-xs uppercase tracking-widest text-slate-500">// governance is a product</p>
          <div>
            <blockquote className="font-display text-2xl leading-snug tracking-tight text-slate-900">
              &quot;We stopped copy-pasting the same rules into every terraform repo.
              Toastern is our single source of truth for cloud policies.&quot;
            </blockquote>
            <p className="mt-4 text-sm text-slate-500">Platform engineer · Acme Corp</p>
          </div>
          <p className="font-mono-tight text-[11px] text-slate-500">
            azure · aws · terraform · bicep
          </p>
        </div>
      </div>
    </div>
  );
}
